import React, { useEffect, useState, useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { useHistory, useParams } from 'react-router-dom';
import { PrintReportsUrls } from './ReportUrls';
import ComponentToPrint from './ComponentToPrint';
import { Loader } from '../../Components';
import { restRequest , checkError } from '../../Helpers';

const ReportsPrint = (props) => {
  const [images, setImages] = useState([]);
  const [loading, setloading] = useState(true);
  const history = useHistory();
  const { from } = useParams();
  const {
    location: { search },
  } = history;
  const componentRef = useRef();
  const printRef = useRef();
  const print = () => {
    printRef.current.click();
  };
  useEffect(() => {
    if (images.length) print();
  }, [images]);

  useEffect(() => {
    restRequest('get', PrintReportsUrls(from, search))
      .then((res) => {
        setImages(res.path);
        setloading(false);
      })
      .catch((error) => {
        setloading(false);
        props.handleToast(error.message, 'error');
      });
  }, [from, search]);

  const RemoveImages = () => {
    if (images.length) {
      const payload = {
        images,
      };
      setloading(true);
      restRequest('post', 'pdfmobiledelete', payload)
        .then((res) => {
          window.close();
          setloading(false);
        })
        .catch((error) => {
          setloading(false);
          checkError(error);
        });
    }
  };

  const goBackAlert = () => {
    return (
      <>
        <div style={{ clear: 'both' }}>
            <div className="unsync-alert">
              <div className="unsync-desc">
                <p>After taking print, you can close this window</p>
                <a href="#" onClick={RemoveImages}>Click to close</a>
              </div>
            </div>
        </div>
      </>
    );
  };

  return (
    <>
      {loading && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
          }}
        >
          <Loader />
        </div>
      )}
      {goBackAlert()}
      <ReactToPrint
        trigger={() => (
          <button ref={printRef} style={{ display: 'none' }}>
            Print this out!
          </button>
        )}
        content={() => componentRef.current}
      />
      <ComponentToPrint data={images} ref={componentRef} />
    </>
  );
};
export default ReportsPrint;
